export default __webpack_public_path__ + "static/media/Group 1691.eca26b58.png";